import image1 from '../assets/nft_images/image1.png';
import image2 from '../assets/nft_images/image2.png';
import image3 from '../assets/nft_images/image3.png';
import image4 from '../assets/nft_images/image4.png';
import image5 from '../assets/nft_images/image5.png';
import image6 from '../assets/nft_images/image6.png';
import image7 from '../assets/nft_images/image7.png';
import image8 from '../assets/nft_images/image8.png';
import image9 from '../assets/nft_images/image9.png';
import image10 from '../assets/nft_images/image10.png';
import image12 from '../assets/nft_images/image12.png';
import image13 from '../assets/nft_images/image13.png';
import image14 from '../assets/nft_images/image14.png';
import image15 from '../assets/nft_images/image15.png';
import image16 from '../assets/nft_images/image16.png';
import image11 from '../assets/nft_images/image11.png';

export const Data = [
  {
    id: 1,
    img: image1,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 2,
    img: image2,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 3,
    img: image3,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 4,
    img: image4,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 5,
    img: image5,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 6,
    img: image6,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 7,
    img: image7,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 8,
    img: image8,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 9,
    img: image9,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 10,
    img: image10,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 11,
    img: image11,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 12,
    img: image12,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 13,
    img: image13,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 14,
    img: image14,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 15,
    img: image15,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
  {
    id: 16,
    img: image16,
    name: 'Desert King',
    night: '1MBT per night',
    distance: '2345km away',
    available: 'available for 2weeks stay',
  },
];
